import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'subjectField', 'subjectSelect'];

  connect() {
    this.toggleSubjectField();
  }

  toggleSubjectField() {
    if (this.checkboxTarget.checked) {
      this.subjectSelectTarget.disabled = true;
      this.subjectSelectTarget.value = '';
      this.subjectFieldTarget.classList.add('tw-opacity-50');
    } else {
      this.subjectSelectTarget.disabled = false;
      this.subjectFieldTarget.classList.remove('tw-opacity-50');
    }
  }
}
